import { prepareFieldErrors } from 'helpers/formHelpers'
import { FC, useMemo } from 'react'
import cn from 'classnames'
import styles from 'components/features/creditCard/creditCardOnboarding/FormCommonError/FormCommonError.styl'
import resolveErrorById from 'constants/errors'

type FormCommonErrorProps = {
  error: string | undefined | null
  className?: string
}
export const FormCommonError: FC<FormCommonErrorProps> = (props) => {
  const { error, className } = props

  const errors = useMemo(() => {
    return prepareFieldErrors(error || undefined, true)
  }, [error])

  if (!errors || !errors[0]) {
    return null
  }

  return (
    <li className={ cn(styles.error, className) } data-qa-marker='error-list-item'>
      { resolveErrorById(errors[0].text as any) }
    </li>
  )
}
